let localisations = {
  en: {
    studyName: 'Investigating the tolerability of the Vorso Transcutaneous Stimulator system in patients with migraine',
    studyDescription: 'The purpose of this research is to observe the effect of Vorso’s transcutaneous electrical stimulation in subjects suffering from 4-14 migraine days per month (with or without aura).',
    contactInfo: 'If you have any questions about the study, please contact migrainestudy@vorsocorp.com',
    consent: {
      consentTitle: 'Investigating the tolerability of the Vorso Transcutaneous Stimulator system in patients with migraine',
      consentBody: 'Please confirm that you have read and agreed to Vorso Corp to have access to your Migraine Buddy data.',
      consentSuccess: 'You have successfully linked your Migraine Buddy account to the study.',
      successWithdrawMessage: 'You have successfully revoked your consent to link your Migraine Buddy data to the study.',
      withdrawConfirmationBody: 'You are withdrawing your consent to link your Migraine Buddy data to the study. To withdraw from the study, please contact migrainestudy@vorsocorp.com'
    },
    studyIdentifier: {
      studyIdentifierTitle: 'Please enter patient ID Number.',
      studyIdentifierLabel: 'Patient ID Number'
    }
  },
  es: {
    studyName: 'Investigación de la tolerabilidad del sistema estimulador transcutáneo de Vorso en pacientes con migraña',
    studyDescription: 'El propósito de esta investigación es observar el efecto de la estimulación eléctrica transcutánea de Vorso en sujetos que sufren migrañas (con o sin aura) durante 4 a 14 días al mes.',
    contactInfo: 'Si tiene preguntas sobre el estudio, envíe un mensaje a migrainestudy@vorsocorp.com',
    consent: {
      consentTitle: 'Investigación de la tolerabilidad del sistema estimulador transcutáneo de Vorso en pacientes con migraña',
      consentBody: 'Le rogamos confirmar que leyó y autoriza que Vorso Corp examine sus datos de la aplicación Migraine Buddy.',
      consentSuccess: 'Se vinculó satisfactoriamente su cuenta de Migraine Buddy con el estudio.',
      successWithdrawMessage: 'Se revocó satisfactoriamente su consentimiento para vincular sus datos de Migraine Buddy con el estudio.',
      withdrawConfirmationBody: 'Usted está retirando su consentimiento para vincular sus datos de Migraine Buddy con el estudio. Para retirarse del estudio, envíe un mensaje a migrainestudy@vorsocorp.com'
    },
    studyIdentifier: {
      studyIdentifierTitle: 'Ingrese el número de ID del paciente.',
      studyIdentifierLabel: 'Número de ID del paciente'
    }
  }
}

export default localisations
